<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-card style="overflow-x: hidden">
        <v-btn
            icon
            @click="cancelBtn"
        >
            <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-row
            class="flex-child"
        >
<!--            <v-col-->
<!--                cols="12"-->
<!--            >-->
<!--                <v-sheet elevation="2">-->
<!--                    <v-container fluid>-->
<!--                        <v-row align="center">-->
<!--                            <v-col cols="12" md="3" sm="6" xs="3">-->
<!--                                <v-text-field-->
<!--                                    solo-->
<!--                                    hide-details-->
<!--                                    :label="$vuetify.lang.t('$vuetify.custom.student.name')"-->
<!--                                    v-model="searchData.name"-->
<!--                                />-->
<!--                            </v-col>-->
<!--                            <v-col cols="12" md="3" sm="6" xs="3">-->
<!--                                <v-text-field-->
<!--                                    solo-->
<!--                                    hide-details-->
<!--                                    :label="$vuetify.lang.t('$vuetify.custom.student.class')"-->
<!--                                    v-model="searchData.class"-->
<!--                                />-->
<!--                            </v-col>-->
<!--                            <v-col cols="12" md="3" sm="6" xs="3">-->
<!--                                <v-text-field-->
<!--                                    solo-->
<!--                                    hide-details-->
<!--                                    :label="$vuetify.lang.t('$vuetify.custom.student.school')"-->
<!--                                    v-model="searchData.school"-->
<!--                                />-->
<!--                            </v-col>-->
<!--                            <v-col cols="12" md="3" sm="3" xs="3">-->
<!--                                <v-row justify="end">-->
<!--                                    <v-btn color="primary mr-3" @click="initialize" dark large>-->
<!--                                        <v-icon left>mdi-magnify</v-icon>-->
<!--                                        {{ $vuetify.lang.t('$vuetify.custom.searchBtn') }}-->
<!--                                    </v-btn>-->
<!--                                </v-row>-->
<!--                            </v-col>-->
<!--                        </v-row>-->
<!--                    </v-container>-->
<!--                </v-sheet>-->
<!--            </v-col>-->
            <v-col
                cols="12"
            >
                <v-sheet elevation="2">
                    <v-data-table
                        v-model="selected"
                        :headers="headers"
                        :items="desserts"
                        item-key="id"
                        class="elevation-1"
                        multi-sort
                        :loading="loading"
                        :footer-props="footerProps"
                        :loading-text="loadingText"
                        :options.sync="options"
                        :server-items-length="totalDesserts"
                        @update:options="changeOptions"

                    >
                    </v-data-table>
                </v-sheet>
            </v-col>
        </v-row>
    </v-card>
</template>
<style></style>
<script>
    import Mock from 'mockjs';

    export default {
        name: 'school-student',
        model: {
            prop: 'studentDialog',
            event: 'parent-event'
        },
        props: {
            studentDialog: Boolean,
            schoolMsg: Object
        },
        data() {
            return {
                loading: true,
                loadingText: this.$vuetify.lang.t('$vuetify.custom.dataLoading'),
                selected: [],
                footerProps: {
                    showFirstLastPage: true,
                    showCurrentPage: true,
                    //disableItemsPerPage:true,
                },
                searchData: {
                    name: '',
                    class: '',
                    school: ''
                },
                options: {},
                headers: [
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.student.name'), value: 'name',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.student.gender'), value: 'genderDesc',sortable: false
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.student.age'), value: 'age',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.student.class'), value: 'className',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.student.school'), value: 'schoolName',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.student.source'), value: 'sourceTypeDesc',sortable: false
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.custom.student.changeClassNum'), value: 'transferTimes',
                    },
                ],
                totalDesserts: 0,
                desserts: [],
            }

        },
        mounted(){
            this.initialize()
        },
        watch:{
            studentDialog(){
                if(this.studentDialog)
                    this.pageChange()
            }
        },
        methods: {
            pageChange(){
                this.options.page = 1
                this.initialize()
            },
            initialize() {
                this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataLoading')
                this.$api.school.geAlumni(
                    Object.assign({}, {id:this.schoolMsg.id}, this.options)
                ).then(data => {
                    this.loading = false;
                    if (data.data) {
                        this.desserts = data.data;
                        this.totalDesserts = data.total;
                    } else {
                        this.loadingText = this.$vuetify.lang.t('$vuetify.custom.dataNothing')
                    }

                })
                //   this.loading = false;
                //   let data = Mock.mock({
                //       'data|10': [
                //           {
                //               'name': '@cname',
                //               "gender|+1": ['男','女'],
                //               "age|18-40": 40,
                //               "class": 'et2001',
                //               "school": 'xxx学校',
                //               "source": 'xxx',
                //               "changeClassNum|1-10": 10,
                //           }
                //       ]
                //   });
                //   this.desserts = data.data
                //   this.totalDesserts = 10;

            },
            changeOptions(option) {
                this.initialize()
            },
            cancelBtn() {
                this.$emit('parent-event', false);
            }
        },
        components: {},
    }
</script>
